import modal from "src/components/ui-components/Modal/ModalContent.module.css";
import { DataUploadForm } from "./DataUploadForm";

export const DataUploadModalContent = ({
  onDismiss,
}: {
  onDismiss: () => void;
}) => (
  <div className={modal.body}>
    <div className={modal.header}>
      <div className={modal.titleRow}>
        <h2>Add new data table</h2>
      </div>

      <p className={modal.description}>
        Just a few steps to add new data to Dune.
      </p>
    </div>

    <DataUploadForm onDismiss={onDismiss} />
  </div>
);
